export default "/assets/ico-arrow-right.png";